
import ErrorIcon from "@/components/molecules/ErrorIcon.vue";
import ErrorPanel from "@/components/molecules/ErrorPanel.vue";
import ErrorMessage, {ErrorLevelType, errorLevelToNumber, errorNumberToLevel} from "@/components/molecules/ErrorMessage";
import {ERROR_LEVELS} from "@/constants";
import {isString} from "@/utils/TypeUtil";
import {defineComponent, PropType} from "vue";

type PopoverType = {
  popperElm?: HTMLElement;
  doClose(): void;
  doDestroy(): void;
}

type PlacementType =
    'top' | 'top-start' | 'top-end' |
    'bottom' | 'bottom-start' | 'bottom-end' |
    'left' | 'left-start' | 'left-end' |
    'right' | 'right-start' | 'right-end';

type TriggerType = 'hover' | 'click';

export default defineComponent({
  name: 'ErrorPopover',
  components: {
    ErrorPanel, ErrorIcon
  },
  props: {
    errors: {
      type: Array as PropType<ErrorMessage[]>,
      required: true,
    },
    trigger: {
      type: String as PropType<TriggerType>,
      default: 'hover'
    },
    placement: {
      type: String as PropType<PlacementType>,
      default: 'right'
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: '500'
    },
    large: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      popovers: [] as PopoverType[],
    };
  },
  beforeDestroy() {
    for(const popover of this.popovers) {
      popover.doClose();
      popover.doDestroy();
    }
  },
  computed: {
    title(): string | null {
      if(this.hideTitle) {
        return null;
      } else {
        return ERROR_LEVELS[this.errorsView.level];
      }
    },
    widthView(): number | null {
      if(this.width === 'auto') {
        return null;
      } else if(isString(this.width)) {
        return parseInt(this.width, 10);
      } else {
        return this.width;
      }
    },
    errorsView(): ErrorMessage[] & {level: ErrorLevelType} {
      const errors = this.errors ? [...this.errors] : [];
      Object.defineProperty(errors, 'level', {
        get() {
          let errorNumber = -1;
          for(const error of this) {
            errorNumber = Math.max(errorNumber, errorLevelToNumber(error.level));
          }
          return errorNumber === -1 ? '' : errorNumberToLevel(errorNumber);
        }
      });
      return errors as ErrorMessage[] & {level: ErrorLevelType};
    }
  },
  methods: {
    handlePopupCreated(popover: PopoverType) {
      if(popover.popperElm) {
        document.querySelector('#app')?.appendChild(popover.popperElm);
        this.popovers.push(popover);
      }
    }
  }
});
